import { getField } from 'vuex-map-fields'

export default {
  namespaced: true,
  state: {
    token: {}
  },
  getters: {
    getField,
    isAuthenticated: (state) => {
      return Object.prototype.hasOwnProperty.call(state.token, 'token') &&
        Object.prototype.hasOwnProperty.call(state.token, 'validUntil') &&
        (new Date(state.token.validUntil) >= new Date())
    }
  },
  mutations: {
    SECURITY_SET_TOKEN: (state, token) => Object.assign(state, { token })
  }
}
